/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Salary_NegotiationInputs */

const en_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary negotiation tools`)
};

const de_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehaltsverhandlungs-Tools`)
};

const fr_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils de négociation salariale`)
};

const es_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de negociación salarial`)
};

const it_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti per la negoziazione salariale`)
};

const nl_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salarisonderhandelingsgereedschap`)
};

const pl_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narzędzia do negocjacji wynagrodzenia`)
};

const fi_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkaneuvottelutyökalut`)
};

const da_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lønforhandlingsværktøjer`)
};

const sv_pricing_feature_salary_negotiation = /** @type {(inputs: Pricing_Feature_Salary_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löneförhandlingsverktyg`)
};

/**
* | output |
* | --- |
* | "Salary negotiation tools" |
*
* @param {Pricing_Feature_Salary_NegotiationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_salary_negotiation = /** @type {((inputs?: Pricing_Feature_Salary_NegotiationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Salary_NegotiationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_salary_negotiation(inputs)
	if (locale === "fr") return fr_pricing_feature_salary_negotiation(inputs)
	if (locale === "es") return es_pricing_feature_salary_negotiation(inputs)
	if (locale === "it") return it_pricing_feature_salary_negotiation(inputs)
	if (locale === "nl") return nl_pricing_feature_salary_negotiation(inputs)
	if (locale === "pl") return pl_pricing_feature_salary_negotiation(inputs)
	if (locale === "fi") return fi_pricing_feature_salary_negotiation(inputs)
	if (locale === "da") return da_pricing_feature_salary_negotiation(inputs)
	if (locale === "sv") return sv_pricing_feature_salary_negotiation(inputs)
	return en_pricing_feature_salary_negotiation(inputs)
});